var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("email-senders")}},[_c('ja-data-table',{attrs:{"fields":_vm.fields,"items":_vm.emailSenders,"on-row-click":_vm.handleRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }